//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'HorizonTimeLine',
  props: {
    timelineData: {
      // 时间轴数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      // 初始选中年份
      type: Object
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    onClickYear: function onClickYear(year) {
      if (this.value.defaultCheckValue !== year) {
        this.value.defaultCheckValue = year;
        console.log('hello', year);
        this.$emit("change");
      }
    }
  }
};